import * as React from 'react';
import { connect } from 'react-redux';
import store from '@/redux/index';
import { types } from '@/redux/ui/actionsheet';
import ActionSheet from '@/pages/components/common/ui/actionsheet';
import { PickerBox } from '@/pages/components/picker';
import * as FormulaStore from '@/redux/pages/formula';
import * as ConfirmStore from '@/redux/ui/confirm';
import config from '@/server/config';
import request from '@/server/request';
import { parse } from 'query-string';

const Toast = require('react-toast-mobile');

class Formula extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            id: parse(this.props.location.search).id || '',
            labelVisible: false, // 新增标签
            labelText: '', // 新增标签内容
            labelList: [], // 标签列表
            appCategoryList: [], // 应用分类
        };
    }

    public componentDidMount() { 
        this.getLabels();
        this.getAppCategoryList();
    }

    public render() {
        const state = this.state;
        const props = this.props;
        return (
            <section className="expert-edit">
                <div className="expert-edittop">
                    <div className="expert-edititem">
                        <div className="expert-editlabel">
                            <span>*</span>
                            配方名称
                        </div>
                        <div className="expert-editgroup">
                            <input type="text" placeholder="请填写" value={props.name} onChange={() => this.inputChange('name')} />
                        </div>
                    </div>
                    <div className="expert-edititem">
                        <div className="expert-editlabel">
                            <span>*</span>
                            供应商
                        </div>
                        <div className="expert-editgroup" onClick={() => this.selectManufacturer()}>
                            <p className={this.props.supplier ? 'active' : ''}>{this.props.supplierName || '请填写'}</p>
                            <img className="icon-right" src={require('../../../../assets/images/choose.png')} alt="" />
                        </div>
                    </div>
                    <div className="expert-edititem">
                        <div className="expert-editlabel">
                            <span>*</span>
                            配方成分数据
                        </div>
                        <div className="expert-editgroup">
                            <button className="formula-plus" onClick={() => this.addComponent()}><i>+</i>添加</button>
                        </div>
                    </div>
                    {
                        props.component.map((v: any, k: number) => { 
                            return (
                                <div className="expert-edititem" key={k+v} onClick={() => this.toComponent(k)}>
                                    <div className="expert-editgroup formula-select">
                                        <p className={v.name ? 'align-right active' : 'align-right'}>{v.name ? `${v.name}-${this.props.component2[k]}-${this.props.model[k]}-${this.props.quality[k]}` : '请选择'}</p>
                                        <img className="icon-right" src={require('../../../../assets/images/choose.png')} alt="" />
                                    </div>
                                </div>
                            )
                        })
                    }
                    
                </div>
                <div className="expert-edittop">
                    <div className="expert-edititem" onClick={() => this.writeIntroduction()}>
                        <div className="expert-editlabel">
                            <span>*</span>
                            配方介绍
                        </div>
                        <div className="expert-editgroup">
                            <p className={this.props.introduction ? 'active' : ''}>{this.props.introduction || '请填写'}</p>
                            <img className="icon-right" src={require('../../../../assets/images/choose.png')} alt="" />
                        </div>
                    </div>
                    <div className="expert-edititem" onClick={() => this.writeTechnology()}>
                        <div className="expert-editlabel">
                            <span>*</span>
                            工艺流程
                        </div>
                        <div className="expert-editgroup">
                            <p className={this.props.process ? 'active' : ''}>{this.props.process || '请填写'}</p>
                            <img className="icon-right" src={require('../../../../assets/images/choose.png')} alt="" />
                        </div>
                    </div>
                    <div className="expert-edititem" onClick={() => this.writeConstruction()}>
                        <div className="expert-editlabel">
                            施工指导
                        </div>
                        <div className="expert-editgroup">
                            <p className={this.props.guidance ? 'active' : ''}>{this.props.guidance || '请填写'}</p>
                            <img className="icon-right" src={require('../../../../assets/images/choose.png')} alt="" />
                        </div>
                    </div>
                    <div className="expert-edititem">
                        <div className="expert-editlabel">
                            <span>*</span>
                            标签特点
                        </div>
                        <div className="expert-editgroup">
                            <button className="formula-plus" onClick={() => this.addLabel(true)}><i>+</i>添加</button>
                        </div>
                    </div>
                    <div className="formula-labels">
                        {
                            state.labelList.map((v: any, k: number) => { 
                                return (
                                    <p key={v.label_id} className={props.labels.indexOf(v.label_id) > -1 ? 'active' : ''}>
                                        <span onClick={() => this.toggleLabels(v.label_id)}>{v.label_name}</span>
                                    </p>
                                )
                            })
                        }
                    </div>
                </div>
                <div className="expert-edittop">
                    <div className="expert-edititem" onClick={() => this.file()}>
                        <div className="expert-editlabel">
                            详细文档
                        </div>
                        <div className="expert-editgroup">
                            <p className={props.doc ? 'active' : ''}>{props.doc ? '已上传' : '请上传'}</p>
                            <img className="icon-right" src={require('../../../../assets/images/choose.png')} alt="" />
                        </div>
                    </div>
                    <div className="expert-edititem">
                        <div className="expert-editlabel">
                            <p>企业LOGO</p>
                            <p><em>(图片尺寸：180x60像素)</em></p>
                        </div>
                        <div className="expert-editgroup" onClick={() => this.photoGraph()}>
                            <div className="upload">
                                {
                                    props.logo ?
                                        <img src={`${config.ULKAPI}${props.logo}`} alt="" /> : <span>+</span>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="expert-edititem" onClick={() => this.selectAppCategory()}>
                        <div className="expert-editlabel">
                            <span>*</span>
                            选择应用分类
                        </div>
                        <div className="expert-editgroup">
                            <p className={props.appCategory ? 'active' : ''}>{props.appCateName || '请选择'}</p>
                            <img className="icon-right" src={require('../../../../assets/images/choose.png')} alt="" />
                        </div>
                    </div>
                </div>
                <div className="expert-editbottom">
                    <button className="btn-submit" onClick={() => this.submitAction()}>发布</button>
                </div>
                <div className={`formula-labels-add ${state.labelVisible ? 'active' : ''}`}>
                    <div className="formula-labels-addc">
                        <strong>标签名</strong>
                        <div className="formula-labels-form">
                            <input type="text" placeholder="输入标签名" defaultValue={state.labelText} onChange={() => this.labelInput()}/>
                        </div>
                        <div className="formula-labels-addbtn">
                            <p onClick={() => this.addLabel(false)}>取消</p>
                            <p onClick={() => this.confirmAddLabel()}>确定</p>
                        </div>
                    </div>
                </div>
                <ActionSheet project="ylk" />
            </section>
        )
    }
    
    // 获取标签列表
    private async getLabels() { 
        const r = await request({
            url: `${config.ULKAPI}api/web/index.php?r=second/search/formula-label`,
            method: 'post',
            data: {
                pageSize: 1000
            }
        });
        if (r.error_code === 0) { 
            this.setState({
                labelList: r.data.model
            });
        }
    }

    // 获取应用分类
    private async getAppCategoryList() { 
        const r = await request({
            url: `${config.ULKAPI}api/web/index.php?r=second/search/adhibition-type`,
            method: 'post'
        });
        if (r.error_code === 0 && r.data) { 
            const temp: any = [];
            r.data.forEach((v: any) => { 
                temp.push({
                    name: v.name,
                    value: v.id
                });
            }); 
            this.setState({
                appCategoryList: temp
            });
        }
    }

    // 新增新标签
    private async addLabelAction() { 
        const r = await request({
            url: `${config.ULKAPI}api/web/index.php?r=member/formula/add-label`,
            method: 'post',
            data: {
                name: this.state.labelText
            }
        });
        if (r.error_code === 0) { 
            const temp = this.state.labelList;
            temp.unshift({
                label_id: r.data,
                label_name: this.state.labelText
            });
            this.setState({
                labelList: temp,
                labelText: '',
                labelVisible: false
            });
        }
    }

    /**
     * 处理输入框文本变化
     * @param modelName {string} 模块名称
     */
    private inputChange(modelName: string) {
        store.dispatch({
            type: FormulaStore.types.INPUT,
            data: {
                key: modelName,
                value: (event as any).target.value
            }
        });
    }
    /**
     * 拍照上传图片
     */
    private photoGraph() {
        store.dispatch({
            type: types.ACTIONSHEET_SHOW,
            callback(r: any) { 
                store.dispatch({
                    type: FormulaStore.types.INPUT,
                    data: {
                        key: 'logo',
                        value: r.data.url
                    }
                });
            }
        });
    }
    // 上传文件
    private file() { 
        store.dispatch({
            type: types.ACTIONSHEET_SHOW,
            data: {
                type: 'file'
            },
            callback(r: any) { 
                if (r.flag === 1) {
                    store.dispatch({
                        type: FormulaStore.types.INPUT,
                        data: {
                            key: 'doc',
                            value: r.data.url
                        }
                    });
                } else { 
                    Toast.T.notify(r.msg);
                }
            }
        });
    }

    /**
     * 新增标签
     * @param visible {boolean} 显示或者隐藏
     */
    private addLabel(visible: boolean) { 
        this.setState({
            labelVisible: visible
        });
    }

    // 确定添加标签
    private confirmAddLabel() { 
        if (this.state.labelText === '') { 
            return Toast.T.notify('请填写标签名称');
        }
        this.addLabelAction();
    }

    // 输入新标签
    private labelInput() { 
        this.setState({
            labelText: (event as any).target.value
        });
    }

    /**
     * 选择取消标签
     * @param id {number} 标签id
     */
    private toggleLabels(id: number) { 
        const labels = this.props.labels; 
        const index = labels.indexOf(id);
        if (index > -1) {
            labels.splice(index, 1);
        } else if (labels.length < 3) { 
            labels.push(id);
        }
        store.dispatch({
            type: FormulaStore.types.INPUT,
            data: {
                key: 'labels',
                value: labels
            }
        });
    }

    // 选择应用分类
    private selectAppCategory() { 
        (PickerBox as any).open({
            data: [{
                displayValue(item: any) {
                    return item.name;
                },
                list: this.state.appCategoryList,
            }],
            // 成功回调
            onConfrim: (data: any) => {
                store.dispatch({
                    type: FormulaStore.types.CONCAT,
                    concatData: {
                        appCategory: data.value,
                        appCateName: data.name
                    }
                });
            }
        });
    }

    // 选择生产商
    private selectManufacturer() { 
        this.props.history.push('/u/product/selectmanufacturer?type=2');
    }

    // 填写配方介绍
    private writeIntroduction() { 
        this.props.history.push('/u/formula/introduction');
    }

    // 填写工艺流程
    private writeTechnology() { 
        this.props.history.push('/u/formula/technology');
    }

    // 填写施工指导
    private writeConstruction() {
        this.props.history.push('/u/formula/construction');
    }

    // 添加一个成分
    private addComponent() { 
        const [tempComponent, tempComponent2, tempModel, tempQuality] =
            [this.props.component, this.props.component2, this.props.model, this.props.quality];
        tempComponent.push({
            name: '',
            value: ''
        });
        tempComponent2.push('');
        tempModel.push('');
        tempQuality.push('');
        store.dispatch({
            type: FormulaStore.types.CONCAT,
            concatData: {
                component: tempComponent,
                component2: tempComponent2,
                model: tempModel,
                quality: tempQuality
            }
        });
    }

    /**
     * 填写成分
     * @param index 组分索引
     */
    private toComponent(index: number) { 
        this.props.history.push(`/u/formula/component?index=${index}`);
    }

    // 提交数据
    private async submitAction() {
        const props = this.props;
        if (props.name === '') {
            return Toast.T.notify('请填写配方标题');
        }
        if (props.name.length > 100) { 
            return Toast.T.notify('配方标题最多只能100字');
        }
        if (props.supplier === '') { 
            return Toast.T.notify('请选择供应商');
        }
        let writeComponent = true;
        let componentIndex = -1;
        const componentValue: string[] = [];
        props.component.forEach((v: any, k: number) => {
            componentValue.push(v.value);
            if (!v.value) { 
                writeComponent = false;
                componentIndex = k + 1;
            }
        });
        if (!writeComponent) { 
            return Toast.T.notify(`请完善第${componentIndex}个配方成分数据`);
        }
        if (props.introduction === '') { 
            return Toast.T.notify('请填写配方介绍');
        }
        if (props.process === '') { 
            return Toast.T.notify('请填写工艺流程');
        }
        if (props.labels.length === 0) { 
            return Toast.T.notify('请选择标签特点');
        }
        if (props.appCategory === '') { 
            return Toast.T.notify('请选择应用分类');
        }
        let data = `FORMULA_NAME=${props.name}&FORMULA_COMPANY=${props.supplierName}&MUNUFACTURER_ID=${props.supplier}&MUNUFACTURER_ABBREVIATION=${props.supplierAbbreviation}`;
        componentValue.forEach((v: string | number) => {
            data += `&grouping[]=${v}`;
        });
        props.component2.forEach((v: string | number) => { 
            data += `&component[]=${v}`;
        });
        props.model.forEach((v: string | number) => { 
            data += `&GRADE[]=${v}`;
        });
        props.quality.forEach((v: string | number) => { 
            data += `&RATIO[]=${v}`;
        });
        props.labels.forEach((v: string | number) => { 
            data += `&label_val[]=${v}`;
        });
        data += `&FORMULA_INTRODUCE=${props.introduction}&TECHNOLOGICAL_PROCESS=${props.process}&CONSTRUCTION_GUIDANCE=${props.guidance}&ADHIBITION_TYPE=${props.appCategory}&FORMULA_PDF=${props.doc}&LOGO=${props.logo}&FORMULA_ID=${this.state.id}&DETAILS_IDS[]=&DETAILS_NAME[]=&MUNUFACTURER_NAME[]=`;
        console.log(data);
        const r = await request({
            url: `${config.ULKAPI}api/web/index.php?r=member/formula/save`,
            method: 'post',
            data,
        });
        if (r.error_code === 0) {
            store.dispatch({
                type: FormulaStore.types.CLEAR
            });
            this.props.history.push('/u/list?type=5');
        } else { 
            store.dispatch({
                type: ConfirmStore.types.CONFIRM_SHOW,
                data: {
                    text: r.msg,
                    type: 2
                }
            });
        }
    }
}

const mapStateToProps = (state: any):FormulaStore.IFormulaStoreState => { 
    return {
        ...state.formulaReducers
    }
}

export default connect(mapStateToProps)(Formula);